'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:core:supportApis');
}

var _invoke = require('../invoke');

/**
 * 获取桥协议版本
 *
 * 支持版本
 * + iHotel/6.1+
 * + HBNB/?
 *
 * @memberof core
 * @static
 * @name supportApis
 * @return {Promise<Array>}
 * @example
 *  hbnb.core.supportApis([
 *      'magpie://ui/alert',
 *      'magpie://what/the_f**k'
 *  ])
 *      .then(function(status) {
 *          status = [
 *              true,
 *              false
 *          ]
 *      });
 */

module.exports = function(apis) {
    if (process.env.NODE_ENV !== 'production') {
        debug('apis is %j', apis);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('core', 'support_apis', {
            callback: function(status) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('status is %j', status);
                }
                resolve(status);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/core/support_apis.js
// module id = 574
// module chunks = 0